<template>
  <div id="container">
    <div v-if="dataReady">
      <vs-row vs-w="12" vs-type="flex" vs-justify="center" class="mb-1">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <span class="stockTitle">CS</span>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <span class="stockTitle">OS</span>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" vs-type="flex" vs-justify="center" class="mb-5">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-button color="green" size="large" class=" text-white font-bold" style="height: 70px;">{{ totalCS
          }}</vs-button>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-button color="green" size="large" class="  text-white font-bold" style="height: 70px;">{{ totalOS
          }}</vs-button>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" vs-type="flex" vs-justify="center">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <span class="companyTitle">RESB</span>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <span class="companyTitle">REEM</span>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" vs-type="flex" vs-justify="center">
        <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <vx-card title="Total Line Item"
            class=" vx-col flex items-center justify-center flex-col   mx-auto text-center">
            <donutHandler :dasbhboardData="resbLineItem"></donutHandler>
          </vx-card>&nbsp;&nbsp;
        </vs-col>
        <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">

          <vx-card title="TOTAL STOCK BALANCE"
            class=" vx-col flex items-center justify-center flex-col   mx-auto text-center">
            <donutHandler :dasbhboardData="resbTotalQty"></donutHandler>
          </vx-card>&nbsp;&nbsp;
        </vs-col>
        <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <vx-card title="Total Line Item"
            class=" vx-col flex items-center justify-center flex-col   mx-auto text-center">
            <donutHandler :dasbhboardData="reemLineItem"></donutHandler>
          </vx-card>&nbsp;&nbsp;
        </vs-col>
        <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">

          <vx-card title="TOTAL STOCK BALANCE"
            class=" vx-col flex items-center justify-center flex-col   mx-auto text-center">
            <donutHandler :dasbhboardData="reemTotalQty"></donutHandler>
          </vx-card>&nbsp;&nbsp;
        </vs-col>
      </vs-row>
    </div>


  </div>
</template>
<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { axiosMixin } from '../../mixin/axiosMixin';
import donutHandler from './donutHandler.vue'
export default {
  mixins: [axiosMixin],
  components: {
    StatisticsCardLine,
    donutHandler
  },
  data() {
    return {
      resbLineItem: {},
      resbTotalQty: {},
      reemTotalQty: {},
      reemLineItem: {},
      totalCS: 0,
      totalOS: 0,
      dataReady: false
    }
  },
  methods: {
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    getData() {
      this.startLoading();
      this.aronPost('getMainDashboard', {}, '', '')
        .then(response => {
          if (response.status) {
            this.resbLineItem = response.data.resbLineItem;
            this.resbTotalQty = response.data.resbTotalQty;
            this.reemTotalQty = response.data.reemTotalQty;
            this.reemLineItem = response.data.reemLineItem;
            this.totalCS = response.data.totalCS;
            this.totalOS = response.data.totalOS;
          } else {
            this.errorAlert('Error', response.data.error)
          }
          this.dataReady = true;
          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error);
          this.stopLoading();
        })
    }

  },
  mounted() {
    this.dataReady = false;
    this.getData();
  },
  created() {

  }
};
</script>
<style scoped>
.donutTitle {
  font-size: 18px;
  font-weight: bold;
  color: white;
}

.companyTitle {
  font-size: 30px;
  font-weight: bold;
  color: white;
  padding: 10px;
}

.stockTitle {
  font-size: 28px;
  font-weight: bold;
  color: white;
}
</style>


